"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = exports.createSchema = void 0;
var yup = __importStar(require("yup"));
var other_1 = require("../../../constants/other");
var routes_1 = require("../../../constants/routes");
exports.createSchema = yup.object({
    psalmsChapter: yup.string().optional(),
    encouragementMessage: yup.string().optional(),
    prayer: yup.string().optional(),
    video: yup.string().optional(),
    gender: yup.string().oneOf(['male', 'female']).required(other_1.VALIDATION_ERROR.REQUIRED),
    image: yup.string().optional(),
    category: yup.string().optional(),
    isPinned: yup.boolean().default(false),
    status: yup.string().oneOf(['pending', 'approved', 'rejected']).required(other_1.VALIDATION_ERROR.REQUIRED),
    personName: yup.string().required(other_1.VALIDATION_ERROR.REQUIRED),
    motherName: yup.string().required(other_1.VALIDATION_ERROR.REQUIRED),
    description: yup.string().required(other_1.VALIDATION_ERROR.REQUIRED),
    shareLinks: yup
        .object({
        facebook: yup.string().optional(),
        twitter: yup.string().optional(),
        instagram: yup.string().optional(),
        tiktok: yup.string().optional(),
    })
        .required(other_1.VALIDATION_ERROR.REQUIRED),
});
exports.ROUTE = routes_1.PRAYER_HUBS;
//# sourceMappingURL=params.js.map